(ns basic-components.inputs.text
  (:require
   [basic-components.inputs.footprint :refer [display-string editor viewer]]
   [common.entity :as entity]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [oops.core :as oops]
   [reagent.core :as r]
   [ui.dom-globals :as dg]))

(defn render
  [dom-atom args]
  (let [{:keys [value placeholder class-name
                has-focus? cursor-at-end-on-focus?
                on-focus! on-blur! on-change!
                on-key-down! disabled? auto-focus]}
        args
        edit-value (or (:temp-value @dom-atom) value)
        render-value (str (if (nil? edit-value) value edit-value))
        clear-state! (fn []
                       (swap! dom-atom dissoc :temp-value))]
    [:input
     (merge {:ref         (fn [e]
                            (when (and e
                                       (not= e (:input-dom-node @dom-atom)))
                              (swap! dom-atom assoc :input-dom-node e)))
             :placeholder (or placeholder "")
             :class-name  (fu/cs "input-area"
                                 (when (or has-focus?
                                           (:focus? @dom-atom))
                                   "focus")
                                 class-name)
             :value       render-value
             :on-focus    (fn [e]
                            (swap! dom-atom assoc :focus? true)
                            (fu/timeout 50                                                          ;; must do this in timeout since focus may be called before mount
                                        (fn []
                                          (cond cursor-at-end-on-focus?
                                                (fu/put-cursor-at-end! dom-atom)
                                                :else                                               ;TODO - add select-all-on-focus?
                                                (oops/ocall (:input-dom-node @dom-atom) "select"))))
                            (when on-focus!
                              (on-focus! e))
                            true)
             :on-change   (fn [e]
                            (let [new-value (dg/event-target-value e)]
                              (swap! dom-atom assoc :temp-value new-value)
                              (when on-change!
                                (on-change! e new-value))))
             :on-blur     (fn [e]
                            (swap! dom-atom dissoc :focus?)
                            (when on-blur!
                              (on-blur! e render-value clear-state!)))
             :on-key-down (fn [e]
                            (when on-key-down!
                              (on-key-down! e)))
             :auto-focus  (boolean auto-focus)}
            (when disabled?
              {:disabled true}))]))

(defmethod editor :editor.type/text-simple
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]
    ;; ref vs atom
    (r/create-class
     {:display-name           "Text"
      :component-did-mount    (fn [_]
                                (let []
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value)
                                                        (deref dom-atom)
                                                        (when-let [dom-node (:input-dom-node @dom-atom)]
                                                          (.blur dom-node)))))
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defmethod editor :editor.type/text-mention
  [args]
  [editor (assoc args :editor/type :editor.type/text-simple)])

(defmethod display-string :editor.type/text-simple
  [args]
  (let [value (:value args)]
    (cond
      (string? value)
      value

      (= (:value-type args) :entity)
      (or (entity/resolve-entity-name (get @session/entities value)
                                      session/get-entity
                                      session/reverse-lookup)
          (entity/display-string (get @session/entities value)))

      :else
      (str value))))

(defmethod display-string :editor.type/text-mention
  [args]
  (display-string (assoc args :editor/type :editor.type/text-simple)))

(defmethod viewer :editor.type/text-simple
  [_args]
  (r/create-class
   {:display-name   "text/viewer"
    :reagent-render (fn [args]
                      [:div.input-text-viewer
                       (display-string args)])}))

(defmethod viewer :editor.type/text-mention
  [args]
  [viewer (assoc args :editor/type :editor.type/text-simple)])
